var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M7.737 1C4.017 1 1 3.923 1 7.526c0 1.22.351 2.361.955 3.337L1.1 13.956l3.192-.828a6.85 6.85 0 0 0 3.445.925c3.72 0 6.737-2.923 6.737-6.527S11.457 1 7.737 1M4.515 6.107h6.444M4.515 7.81h6.444M4.515 9.513h6.444"
})));
export default SvgComment;